import app from "firebase/app";
import React from "react";

import {
  FIREBASE_API_KEY,
  FIREBASE_PROJECT_ID,
  FIREBASE_APP_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_PUBLIC_VAPID_KEY,
  AUTH_TOKEN,
} from "./constants";
import "firebase/messaging";
import UpdateUserMessagingTokenMutation from "./mutations/users/UpdateUserMessagingTokenMutation";

const config = {
  apiKey: FIREBASE_API_KEY,
  projectId: FIREBASE_PROJECT_ID,
  appId: FIREBASE_APP_ID,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.isLoaded = false;
    if (app.messaging.isSupported()) {
      this.messaging = app.messaging();
      this.messaging.usePublicVapidKey(FIREBASE_PUBLIC_VAPID_KEY);
      this.isLoaded = true;
    }
  }

  updateUserMessagingToken(token) {
    if (token) {
      UpdateUserMessagingTokenMutation(token, (payload) => {
        console.log("Updated");
      });
    } else {
      console.log(
        "Device token must be passed to updateUserMessagingToken method"
      );
    }
  }
}

const FirebaseContext = React.createContext(null);

export default Firebase;
export { FirebaseContext };



// WEBPACK FOOTER //
// ./src/Firebase.js